module.exports = __webpack_public_path__ + "static/media/melorra1.5656f8e5.webp";